// extracted by mini-css-extract-plugin
export default {"Container":"MailSuccess_Container__1zKnM"};